module.exports = __webpack_public_path__ + "image/detail_image_pc_c6645.png";